import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
<>
  <title>STS website</title>

  <link rel="icon" href="%PUBLIC_URL%/favicon.ico" />
</>;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
